module.exports = __webpack_public_path__ + "fonts/UcCm3FwrK3iLTcvnUwQT9mI1F54.8f4c018.woff2";